export const environment = {
  apiConnectURL: "https://api-dev.fgc.org.br/portalpj",
  apiConnectDpgeURL: "https://api-dev.fgc.org.br/portalpj-dpge",
  apiConnectAppUrl: "https://api-dev.fgc.org.br/v1",
  privacyPolicy: "https://www.fgc.org.br/documents/d/asset-library-52554/politica-de-privacidade-do-fgc-1",
  production: false,
  cognito: {
    UserPoolId: "us-east-1_OxYqcEzJP",
    ClientId: "5kjlq8ocjtca932geh54cbgk10",
  },
};
